/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvestigatorDto } from '../models/InvestigatorDto';
import type { InvestigatorUpdateDto } from '../models/InvestigatorUpdateDto';
import type { MultipleInvestigatorNotificationUpdateDto } from '../models/MultipleInvestigatorNotificationUpdateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class InvestigatorService {

    /**
     * Get site-study investigators
     * @param siteStudyId
     * @returns InvestigatorDto
     * @throws ApiError
     */
    public static investigatorControllerGet(
        siteStudyId: number,
    ): CancelablePromise<Array<InvestigatorDto>> {
        return __request({
            method: 'GET',
            path: `/investigator`,
            query: {
                'siteStudyId': siteStudyId,
            },
        });
    }

    /**
     * Upsert site-study investigator; when site_code is set, also applies to StudySites with the same site_code, study, and language family
     * @param requestBody
     * @returns InvestigatorDto
     * @throws ApiError
     */
    public static investigatorControllerPut(
        requestBody: InvestigatorUpdateDto,
    ): CancelablePromise<InvestigatorDto> {
        return __request({
            method: 'PUT',
            path: `/investigator`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Remove investigator from related StudySites (same site_code + study + language, or same study/site/language when no site_code)
     * @param studySite
     * @param siteEmployeeId
     * @returns InvestigatorDto
     * @throws ApiError
     */
    public static investigatorControllerDeleteByStudySiteAndEmployee(
        studySite: string,
        siteEmployeeId: string,
    ): CancelablePromise<Array<InvestigatorDto>> {
        return __request({
            method: 'DELETE',
            path: `/investigator`,
            query: {
                'studySite': studySite,
                'siteEmployeeId': siteEmployeeId,
            },
        });
    }

    /**
     * Get site-study investigators
     * @returns MultipleInvestigatorNotificationUpdateDto
     * @throws ApiError
     */
    public static investigatorControllerGetInvestigatorStudies(): CancelablePromise<MultipleInvestigatorNotificationUpdateDto> {
        return __request({
            method: 'GET',
            path: `/investigator/studies`,
        });
    }

    /**
     * update investigator notifications
     * @param requestBody
     * @returns InvestigatorDto
     * @throws ApiError
     */
    public static investigatorControllerUpdateInvestigatorNotifications(
        requestBody: MultipleInvestigatorNotificationUpdateDto,
    ): CancelablePromise<InvestigatorDto> {
        return __request({
            method: 'PUT',
            path: `/investigator/updateNotification`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}